module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section white padding-tb-160 register-info"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text padding-30"
  }, [_c('h1', {
    staticClass: "lato size-34 txt-black xs-centered"
  }, [_vm._v("Cómo registrarse")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-30 regular txt-black"
  }, [_vm._v("1. Contacta con el administrador Andalepide de tu empresa y solicita tu cuenta única.")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-30 regular txt-black"
  }, [_vm._v("2. Se te enviará un link privado donde accederás al menú de pedidos y hacé click en el botón \"Crear Cuenta\"")]), _vm._v(" "), _c('div', {
    staticClass: "box-text-btn xs-centered"
  }, [_c('span', {
    staticClass: "size-16 semibold padding-10 txt-black"
  }, [_vm._v("¿Ya tienes una cuenta?")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-outline",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("INICIAR SESIÓN")])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 element-right"
  }, [_c('img', {
    staticClass: "img-section",
    attrs: {
      "src": require("../../assets/images/backgrounds/bg11.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c853be8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/Registro.vue
// module id = 1116
// module chunks = 5